import React from 'react';
import './SkeletonLoader.css';

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton skeleton-title"></div>
    <div className="skeleton skeleton-text"></div>
    <div className="skeleton skeleton-text short"></div>
  </div>
);

export const SkeletonTable = ({ rows = 5, columns = 5 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {[...Array(columns)].map((_, i) => (
        <div key={i} className="skeleton skeleton-header-cell"></div>
      ))}
    </div>
    {[...Array(rows)].map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {[...Array(columns)].map((_, colIndex) => (
          <div key={colIndex} className="skeleton skeleton-cell"></div>
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonKanban = () => (
  <div className="skeleton-kanban">
    {[...Array(3)].map((_, columnIndex) => (
      <div key={columnIndex} className="skeleton-kanban-column">
        <div className="skeleton skeleton-column-title"></div>
        {[...Array(3)].map((_, cardIndex) => (
          <div key={cardIndex} className="skeleton-kanban-card">
            <div className="skeleton skeleton-card-title"></div>
            <div className="skeleton skeleton-card-text"></div>
            <div className="skeleton skeleton-card-text short"></div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonDashboard = () => (
  <div className="skeleton-dashboard">
    <div className="skeleton-stats">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="skeleton-stat-card">
          <div className="skeleton skeleton-stat-value"></div>
          <div className="skeleton skeleton-stat-label"></div>
        </div>
      ))}
    </div>
    <div className="skeleton-charts">
      <div className="skeleton-chart">
        <div className="skeleton skeleton-chart-title"></div>
        <div className="skeleton skeleton-chart-body"></div>
      </div>
      <div className="skeleton-chart">
        <div className="skeleton skeleton-chart-title"></div>
        <div className="skeleton skeleton-chart-body"></div>
      </div>
    </div>
  </div>
);

export const SkeletonJobDetails = () => (
  <div className="skeleton-job-details">
    <div className="skeleton skeleton-job-title"></div>
    <div className="skeleton skeleton-job-subtitle"></div>
    <div className="skeleton-job-info">
      <div className="skeleton skeleton-info-row"></div>
      <div className="skeleton skeleton-info-row"></div>
      <div className="skeleton skeleton-info-row"></div>
    </div>
    <div className="skeleton skeleton-section-title"></div>
    <div className="skeleton-interviews">
      {[...Array(2)].map((_, i) => (
        <div key={i} className="skeleton-interview-card">
          <div className="skeleton skeleton-interview-header"></div>
          <div className="skeleton skeleton-interview-text"></div>
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonList = ({ items = 5 }) => (
  <div className="skeleton-list">
    {[...Array(items)].map((_, i) => (
      <div key={i} className="skeleton-list-item">
        <div className="skeleton skeleton-avatar"></div>
        <div className="skeleton-list-content">
          <div className="skeleton skeleton-list-title"></div>
          <div className="skeleton skeleton-list-subtitle"></div>
        </div>
      </div>
    ))}
  </div>
);
